import * as React from 'react';

import { cn } from '@/lib/cn';
import type { FieldValues, UseFormReturn } from 'react-hook-form';

export type InputProps = React.InputHTMLAttributes<HTMLInputElement>;

const Input = React.forwardRef<HTMLInputElement, InputProps>(
  ({ className, type, ...props }, ref) => {
    return (
      <input
        type={type}
        className={cn(
          'flex min-h-10 w-full rounded-md border border-input bg-background px-3 py-2 text-sm leading-none text-foreground shadow-input ring-offset-background file:border-0 file:bg-transparent file:text-sm file:font-medium placeholder:text-muted-foreground/70 focus-visible:outline-hidden focus-visible:ring-1 focus-visible:ring-ring focus-visible:ring-offset-0 disabled:cursor-not-allowed disabled:opacity-50',
          className
        )}
        ref={ref}
        {...props}
      />
    );
  }
);
Input.displayName = 'Input';

export type FormInputProps<TFieldValues extends FieldValues = FieldValues> =
  InputProps & {
    label: string;
    name: string;
    placeholder?: string;
    form: UseFormReturn<TFieldValues>;
    description?: string;
  };

export { Input };
